import { Paths } from '../../../shared/paths';

export const notificationsBasePath = `${Paths.adminDashboard.root}${Paths.adminDashboard.notifications}`;
